import {Pipe, PipeTransform} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";
import {SessionState} from "@models";

@Pipe({
	name: "getTrainingSessionStateStringForCustomer",
	pure: false,
	standalone: true,
})
export class GetTrainingSessionStateStringForCustomerPipe implements PipeTransform {
	T = Translations;

	constructor(private _translate: TranslateService) {}

	transform(value: SessionState) {
		switch (value) {
			case SessionState.Aborted:
				return this._translate.instant(this.T.SHARED_TRAINING_SESSION_STATE_ABORTED);
			case SessionState.Canceled:
				return this._translate.instant(this.T.SHARED_TRAINING_SESSION_STATE_CANCELED);
			case SessionState.Started:
				return this._translate.instant(this.T.SHARED_TRAINING_SESSION_STATE_STARTED);
			case SessionState.Running:
				return this._translate.instant(this.T.SHARED_TRAINING_SESSION_STATE_RUNNING);
			case SessionState.Draft:
				return this._translate.instant(this.T.SHARED_TRAINING_SESSION_STATE_DRAFT);
			case SessionState.Scheduled:
				return this._translate.instant(this.T.SHARED_TRAINING_SESSION_STATE_SCHEDULED);
			case SessionState.Paused:
				return this._translate.instant(this.T.SHARED_TRAINING_SESSION_STATE_PAUSED);
			case SessionState.Finished:
				return this._translate.instant(this.T.SHARED_TRAINING_SESSION_STATE_FINISHED);

			// map stoppped to finished
			case SessionState.Stopped:
				return this._translate.instant(this.T.SHARED_TRAINING_SESSION_STATE_FINISHED);
		}
	}
}
